// Fetch wrapper for GET /app/api/search. Mirrors api-mutations.js conventions.
// Attached to window.mindexApiSearch by vendor.entry.js.

export class NetworkError extends Error {
  constructor(message, { status, body } = {}) {
    super(message);
    this.name = 'NetworkError';
    this.status = status;
    this.body = body;
  }
}

export async function apiSearch({ orgSlug, wsHandle, q, regex = false, caseSensitive = false, signal }) {
  const url =
    '/app/api/search?org=' + encodeURIComponent(orgSlug) +
    '&workspace=' + encodeURIComponent(wsHandle) +
    '&q=' + encodeURIComponent(q) +
    '&regex=' + (regex ? '1' : '0') +
    '&case=' + (caseSensitive ? '1' : '0');
  const opts = signal ? { signal } : {};
  const r = await fetch(url, opts);
  const body = await r.json().catch(() => ({}));
  if (!r.ok) {
    throw new NetworkError('/app/api/search ' + r.status, { status: r.status, body });
  }
  return {
    groups: body.groups ?? [],
    truncated: !!body.truncated,
    needs_literal: !!body.needs_literal,
  };
}
